
/**
 * Social channel detection
 * 
 * This is a list of social media platforms that are commonly used.
 */
const platforms : Array<string> = [
    'facebook',
    'twitter',
    // use leading slashes to indicate that
    // we don't want to match on a partial domain match
    // (for these shorter domain names)
    '/x.com', // x aka twitter
    '/t.co', // x aka twitter tracking proxy domain (outbound links)
    'linkedin',
    'instagram',
    'pinterest',
    'tiktok',
    'snapchat',
];


export default class SocialChannel {
    
    public static is(referrer: string) : boolean {

        for (let i = 0; i < platforms.length; i ++) {
            const platformName = platforms[i];
            if (referrer.indexOf(platformName) !== -1) {
                return true;
            }
        }
        return false;
    }

}
